import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useAuth } from "./AuthContext";
import { PageSpinner } from "../ui/Spinner";

/** Bloque les routes privées tant qu'on n'est pas authentifié. */
export function AuthGuard({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") return <PageSpinner />;
  if (status === "anonymous") return <Navigate to="/login" replace />;
  return <>{children}</>;
}

/** Redirige les déjà-authentifiés loin de /login. */
export function GuestGuard({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") return <PageSpinner />;
  if (status === "authenticated") return <Navigate to="/" replace />;
  return <>{children}</>;
}
